import { Box } from '@mui/material'

import { CONTENT_WRAPPER_SX_PC } from '@/constants.ts'
import { LayoutTitle } from '@/components'
import { PermissionCheck } from '@/layouts/dashboard/permission-check.tsx'

export const MainContent = () => {
  return (
    <Box sx={CONTENT_WRAPPER_SX_PC}>
      <LayoutTitle />
      <Box minHeight="50vh">
        <PermissionCheck />
      </Box>
    </Box>
  )
}
